import { render, staticRenderFns } from "./studentTec.vue?vue&type=template&id=5a87dfbd&scoped=true&"
import script from "./studentTec.vue?vue&type=script&lang=js&"
export * from "./studentTec.vue?vue&type=script&lang=js&"
import style0 from "./studentTec.vue?vue&type=style&index=0&id=5a87dfbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87dfbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
